"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4733],{

/***/ 94733:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_onlineCounselling_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30555);
/* harmony import */ var _styles_onlineCounselling_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_onlineCounselling_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(34051);
/* harmony import */ var react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(31555);
/* harmony import */ var _CustomImage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45992);
/* harmony import */ var _hooks_useZipmeLink__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98196);
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32866);









const FirstStepWithKC = ({ firstStepEventData , jotformId , externalLink  })=>{
    const { zipmeLink , generateLink  } = (0,_hooks_useZipmeLink__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_styles_onlineCounselling_module_scss__WEBPACK_IMPORTED_MODULE_5___default().firstStep),
            style: {
                backgroundColor: firstStepEventData?.sectionBgColor || "#FFF1EF"
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        xl: 7,
                        lg: 7,
                        md: 12,
                        sm: 12,
                        className: (_styles_onlineCounselling_module_scss__WEBPACK_IMPORTED_MODULE_5___default().stuImgtextd),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_styles_onlineCounselling_module_scss__WEBPACK_IMPORTED_MODULE_5___default().heading),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                children: firstStepEventData?.sectionTitle
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_onlineCounselling_module_scss__WEBPACK_IMPORTED_MODULE_5___default().headingSec),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                            children: firstStepEventData?.testTitle
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_onlineCounselling_module_scss__WEBPACK_IMPORTED_MODULE_5___default().para),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            children: firstStepEventData?.testDescription
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_onlineCounselling_module_scss__WEBPACK_IMPORTED_MODULE_5___default().headingSec),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                            children: firstStepEventData?.offeringsTitle
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_onlineCounselling_module_scss__WEBPACK_IMPORTED_MODULE_5___default().StepContent),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                            className: (_styles_onlineCounselling_module_scss__WEBPACK_IMPORTED_MODULE_5___default().ulItem),
                                            children: firstStepEventData?.offeringsPoints?.length > 0 ? firstStepEventData?.offeringsPoints?.length > 0 && firstStepEventData?.offeringsPoints?.map((offeringsPoints, ind)=>{
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: (_styles_onlineCounselling_module_scss__WEBPACK_IMPORTED_MODULE_5___default().liItem),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                                            src: offeringsPoints?.imageUrl || "/images/starthd.png",
                                                            width: 20,
                                                            height: 20,
                                                            className: (_styles_onlineCounselling_module_scss__WEBPACK_IMPORTED_MODULE_5___default().img),
                                                            alt: "EdTech1"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            children: offeringsPoints.title
                                                        })
                                                    ]
                                                }, ind);
                                            }) : firstStepEventData?.offeringsPoints?.length > 0 && firstStepEventData?.offeringsPoints?.map((title, ind)=>{
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                    children: title
                                                }, ind);
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_onlineCounselling_module_scss__WEBPACK_IMPORTED_MODULE_5___default().anchor),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            onClick: ()=>{
                                                !jotformId && generateLink(externalLink);
                                            },
                                            className: `${(_styles_onlineCounselling_module_scss__WEBPACK_IMPORTED_MODULE_5___default().btnReg)} ${jotformId ? `${(0,_utils_helpers__WEBPACK_IMPORTED_MODULE_4__/* .isFrappeOrJotFormClass */ .gd)(jotformId)}` : ""}`,
                                            children: "Register Now"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                xl: 5,
                                lg: 4,
                                md: 12,
                                sm: 12,
                                className: (_styles_onlineCounselling_module_scss__WEBPACK_IMPORTED_MODULE_5___default().stuImgd),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_styles_onlineCounselling_module_scss__WEBPACK_IMPORTED_MODULE_5___default().image),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                        src: firstStepEventData?.sectionImageUrl || "/images/admissionsday/about-qut.svg",
                                        width: 500,
                                        height: 500,
                                        alt: "qut.svg"
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (FirstStepWithKC);


/***/ })

}]);